/* tslint:disable */
/* eslint-disable */
/**
 * Vayu API
 * The Vayu API is a RESTful API that allows you to submit events for processing and storage & manage billing related entities.           The API is secured using the Bearer Authentication scheme with JWT tokens.           To obtain a JWT token, please contact Vayu at team@withvayu.com
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: dev@withvayu.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import {
    TriggerReportJobRequestOneOf,
    instanceOfTriggerReportJobRequestOneOf,
    TriggerReportJobRequestOneOfFromJSON,
    TriggerReportJobRequestOneOfFromJSONTyped,
    TriggerReportJobRequestOneOfToJSON,
} from './TriggerReportJobRequestOneOf';
import {
    TriggerReportJobRequestOneOf1,
    instanceOfTriggerReportJobRequestOneOf1,
    TriggerReportJobRequestOneOf1FromJSON,
    TriggerReportJobRequestOneOf1FromJSONTyped,
    TriggerReportJobRequestOneOf1ToJSON,
} from './TriggerReportJobRequestOneOf1';
import {
    TriggerReportJobRequestOneOf2,
    instanceOfTriggerReportJobRequestOneOf2,
    TriggerReportJobRequestOneOf2FromJSON,
    TriggerReportJobRequestOneOf2FromJSONTyped,
    TriggerReportJobRequestOneOf2ToJSON,
} from './TriggerReportJobRequestOneOf2';
import {
    TriggerReportJobRequestOneOf3,
    instanceOfTriggerReportJobRequestOneOf3,
    TriggerReportJobRequestOneOf3FromJSON,
    TriggerReportJobRequestOneOf3FromJSONTyped,
    TriggerReportJobRequestOneOf3ToJSON,
} from './TriggerReportJobRequestOneOf3';
import {
    TriggerReportJobRequestOneOf4,
    instanceOfTriggerReportJobRequestOneOf4,
    TriggerReportJobRequestOneOf4FromJSON,
    TriggerReportJobRequestOneOf4FromJSONTyped,
    TriggerReportJobRequestOneOf4ToJSON,
} from './TriggerReportJobRequestOneOf4';
import {
    TriggerReportJobRequestOneOf5,
    instanceOfTriggerReportJobRequestOneOf5,
    TriggerReportJobRequestOneOf5FromJSON,
    TriggerReportJobRequestOneOf5FromJSONTyped,
    TriggerReportJobRequestOneOf5ToJSON,
} from './TriggerReportJobRequestOneOf5';

/**
 * @type TriggerReportJobRequest
 * 
 * @export
 */
export type TriggerReportJobRequest = TriggerReportJobRequestOneOf | TriggerReportJobRequestOneOf1 | TriggerReportJobRequestOneOf2 | TriggerReportJobRequestOneOf3 | TriggerReportJobRequestOneOf4 | TriggerReportJobRequestOneOf5;

export function TriggerReportJobRequestFromJSON(json: any): TriggerReportJobRequest {
    return TriggerReportJobRequestFromJSONTyped(json, false);
}

export function TriggerReportJobRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): TriggerReportJobRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return { ...TriggerReportJobRequestOneOfFromJSONTyped(json, true), ...TriggerReportJobRequestOneOf1FromJSONTyped(json, true), ...TriggerReportJobRequestOneOf2FromJSONTyped(json, true), ...TriggerReportJobRequestOneOf3FromJSONTyped(json, true), ...TriggerReportJobRequestOneOf4FromJSONTyped(json, true), ...TriggerReportJobRequestOneOf5FromJSONTyped(json, true) };
}

export function TriggerReportJobRequestToJSON(value?: TriggerReportJobRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }

    if (instanceOfTriggerReportJobRequestOneOf(value)) {
        return TriggerReportJobRequestOneOfToJSON(value as TriggerReportJobRequestOneOf);
    }
    if (instanceOfTriggerReportJobRequestOneOf1(value)) {
        return TriggerReportJobRequestOneOf1ToJSON(value as TriggerReportJobRequestOneOf1);
    }
    if (instanceOfTriggerReportJobRequestOneOf2(value)) {
        return TriggerReportJobRequestOneOf2ToJSON(value as TriggerReportJobRequestOneOf2);
    }
    if (instanceOfTriggerReportJobRequestOneOf3(value)) {
        return TriggerReportJobRequestOneOf3ToJSON(value as TriggerReportJobRequestOneOf3);
    }
    if (instanceOfTriggerReportJobRequestOneOf4(value)) {
        return TriggerReportJobRequestOneOf4ToJSON(value as TriggerReportJobRequestOneOf4);
    }
    if (instanceOfTriggerReportJobRequestOneOf5(value)) {
        return TriggerReportJobRequestOneOf5ToJSON(value as TriggerReportJobRequestOneOf5);
    }

    return {};
}

